/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EnrollmentPreviewCandidate } from './enrollmentPreviewCandidate';
import type { EnrollmentPreviewResponsePhase } from './enrollmentPreviewResponsePhase';
import type { EnrollmentPreviewResponseWaterfallStrategy } from './enrollmentPreviewResponseWaterfallStrategy';
import type { PreviewBucketCounts } from './previewBucketCounts';

/**
 * Full preview-session shape returned by the create / get / patch endpoints.
 */
export interface EnrollmentPreviewResponse {
  /**
     * @minLength 8
     * @maxLength 64
     */
  preview_session_id: string;
  sequence_id: string;
  pinned_step_set_id: string;
  /** @minimum 1 */
  pinned_step_set_version_number: number;
  waterfall_strategy: EnrollmentPreviewResponseWaterfallStrategy;
  candidates: EnrollmentPreviewCandidate[];
  buckets: PreviewBucketCounts;
  expires_at: string;
  /** @minimum 0 */
  request_seq?: number;
  render_complete?: boolean;
  phase?: EnrollmentPreviewResponsePhase;
  phase_error_code?: string | null;
  /** @minimum 0 */
  reveal_total?: number;
  /** @minimum 0 */
  reveal_done?: number;
  /** @minimum 0 */
  reveal_cached?: number;
}
